import type { LocaleCode } from './locales';
// The header's Features menu (components/Header.vue featureMenu), hand-translated per locale.
// tests/seo/header-features-menu.test.ts checks every locale has every key.
import featuresMenus from './header-features-menu.json' with { type: 'json' };
// The Solutions, Resources and Industries menus (data/header-menus.json); tests/seo/header-menus.test.ts.
import headerMenus from './header-menus.json' with { type: 'json' };

export type FeaturesMenuCopy = (typeof featuresMenus)['en'];
export type HeaderMenusCopy = (typeof headerMenus)['en'];

type HeaderLocalizedCopy = {
  industries: string;
  resources: string;
};

const headerCopy: Record<LocaleCode, HeaderLocalizedCopy> = {
  en: { industries: 'Industries', resources: 'Resources' },
  ar: { industries: 'القطاعات', resources: 'الموارد' },
  cs: { industries: 'Odvětví', resources: 'Zdroje' },
  de: { industries: 'Branchen', resources: 'Ressourcen' },
  el: { industries: 'Κλάδοι', resources: 'Πόροι' },
  es: { industries: 'Sectores', resources: 'Recursos' },
  fi: { industries: 'Toimialat', resources: 'Resurssit' },
  tl: { industries: 'Mga industriya', resources: 'Mga mapagkukunan' },
  fr: { industries: 'Secteurs', resources: 'Ressources' },
  he: { industries: 'תחומים', resources: 'משאבים' },
  hu: { industries: 'Iparágak', resources: 'Források' },
  id: { industries: 'Industri', resources: 'Sumber daya' },
  it: { industries: 'Settori', resources: 'Risorse' },
  ja: { industries: '業種', resources: 'リソース' },
  ko: { industries: '산업', resources: '리소스' },
  ms: { industries: 'Industri', resources: 'Sumber' },
  nl: { industries: 'Sectoren', resources: 'Bronnen' },
  pl: { industries: 'Branże', resources: 'Zasoby' },
  pt: { industries: 'Setores', resources: 'Recursos' },
  ro: { industries: 'Industrii', resources: 'Resurse' },
  ru: { industries: 'Отрасли', resources: 'Ресурсы' },
  sv: { industries: 'Branscher', resources: 'Resurser' },
  th: { industries: 'อุตสาหกรรม', resources: 'แหล่งข้อมูล' },
  tr: { industries: 'Sektörler', resources: 'Kaynaklar' },
  uk: { industries: 'Галузі', resources: 'Ресурси' },
  vi: { industries: 'Ngành', resources: 'Tài nguyên' },
  'zh-Hant': { industries: '產業', resources: '資源' },
};

const menus = featuresMenus as Record<string, FeaturesMenuCopy>;
const otherMenus = headerMenus as Record<string, HeaderMenusCopy>;

export const getHeaderLocalizedCopy = (localeCode: LocaleCode | string) => ({
  ...(headerCopy[localeCode as LocaleCode] || headerCopy.en),
  featuresMenu: menus[localeCode] || menus.en,
  solutionsMenu: (otherMenus[localeCode] || otherMenus.en).solutions,
  resourcesMenu: (otherMenus[localeCode] || otherMenus.en).resources,
  industriesMenu: (otherMenus[localeCode] || otherMenus.en).industries,
});
